<template>
  <div class="question" :style="{ height: height + 'px' }">
    <div :style="{ height: ( height - 20 ) + 'px' }" class="content">
      <div class="rolling">
        <ul class="ul">
          <li @click="question()" v-for="(item,index) in 10" :key="index">
            <h5>英语课程一共有多少个章节？</h5>
            <p>
              <span>樱桃小丸子</span>
              发布于3分钟前 &nbsp;&nbsp;·&nbsp;&nbsp;
              <span>0回答</span>
            </p>
          </li>
        </ul>
      </div>
      <el-input
        type="textarea"
        class="textarea"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
      <div class="sure fr">保存笔记</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      }
    },
    data () {
      return {
        textarea: ''
      }
    },
    created () {

    },
    methods: {
      question () {
        this.$emit('changIndex', 4)
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .question {
    width: 360px;
    margin: 0 auto;
    overflow: hidden;

    .content {
      margin: 20px auto 0;

      .textarea {
        height: 20%;
        margin-top: 10%;

        textarea {
          height: 100%;

          &:focus {
            border: 1px solid #ff827b;
          }
        }
      }

      .rolling {
        height: 60%;
        overflow-x: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        .ul {
          overflow: hidden;

          li {
            height: 60px;
            padding: 10px 0;
            line-height: 30px;
            font-size: 14px;
            border-bottom: 1px solid #ebebeb;
            cursor: pointer;

            h5 {
              font-size: 16px;
              color: #ff827b;
              font-weight: bold;

              &:hover {
                text-decoration: underline;
              }
            }

            p {
              color: #919191;

              span {
                font-size: 14px;
                color: #ff827b;

                &:last-child {
                  color: #333;
                }
              }
            }
          }
        }
      }

      .sure {
        width: 110px;
        height: 40px;
        background-color: #ff8484;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 20px;
        cursor: pointer;
        margin: 20px 0 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/liveLayer/question/question.vue